import * as React from 'react';
import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import userManage from 'src/api/systemManage/userManage';
import department from 'src/api/systemManage/department';
import service from 'src/node_modules/kts-platform-frame/service'
import system from 'src/api/systemManage/system';
import job from 'src/api/systemManage/job';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import { message, Modal } from 'antd';
import { Urls } from 'kts-platform-frame/entry/constant';
import Message from 'kts-scaffold-framework/component/Message';

class ModulesAction extends ActionBasic<ModulesState> {
    public getUserQuery = async (options?: any) => {
        const res = await userManage.userQuery(this, options);
        if (!res.er) {
            this.modulesState.userList = res.res.items;
            this.modulesState.userPageMeta = res.res.pageMeta;
            this.setModulesState();
        }
    }
    tabsOnChange = (key) => {
        this.modulesState.activeKey = key;
        this.setModulesState();
    }
    mapListToPage = (page: number, pageSize?: number) => {
        const pageMeta = {
            pageNum: page,
            pageSize: pageSize ? pageSize : this.modulesState.userListPageMeta.pageSize
        };
        this.modulesState.userListPageMeta = pageMeta;
        this.modulesState.selectedUsers = [];
        const data = {
            ...this.modulesState.userListPageMeta,
            ...this.modulesState.searchOptions,
        };
        this.setModulesState(this.modulesState, () => {
            this.getUserQuery(data);
        });
    }
    public departmentQuery = async () => {
        const res = await department.depList(this);
        if (!res.er) {
            const list = res.res.map(item => {
                return {
                    ...item,
                    label: item.name,
                    value: item.departmentId
                };
            });
            this.modulesState.departmentQuery = list;
            this.setModulesState();
        }
    }

    public updateSearchOptions = options => {
        this.modulesState.searchOptions = options;
        this.setModulesState();
    }

    public updateFilterOptions = options => {
        this.modulesState.filterOptions = options;
        this.setModulesState();
    }

    public updateSelectedUsers = users => {
        this.modulesState.selectedUsers = users;
        this.setModulesState();
    }

    public setDepartment = async options => {
        const res = await userManage.setDepartment(this, options);
        if (!res.er) {
            MyStore.instance.dispatch(reducers.aside.ActionTypes.hide, null);
            Message.success('设置部门成功');
            this.getUserQuery(this.clearOptions());
        }
    }

    public setupUserDisOr = async options => {
        const res = await system.userDisOrEna(this, options);
        if (!res.er) {
            Message.success('操作成功');
            this.getUserQuery(this.clearOptions());
        }
    }

    public invitationUser = async options => {
        const res = await system.userSend(this, options);
        if (!res.er) {
            Message.success('邀请成功');
        }
    }
    /** 上传文件 */
    public sendUpload = async (values) => {
        // this.modulesState.sendupload = true;

        const resp = await userManage.userBatchCreate(this, { file: values });
        if (resp.er) {
            Message.error('接口调用出错');
            return;
        }
        if (resp.res.result) {
            // let result = resp.res.successInfo;
            Message.success(`批量创建成功。`); // ${result.connectionNum} 个, 发送邀请 ${result.invitedNum} 个。`);
            this.getUserQuery({ pageSize: 10, pageNum: 1 });
        } else {
            let failedResult = resp.res.failedInfo || [];
            Modal.error({
                title: '批量创建失败',
                content: failedResult.map((item, index) => {
                    return <p key={index}>名称: {item.name}, 账号: {item.email}, {item.errorMsg} 。</p>;
                }),
            });
        }
        // this.setModulesState()
    }
    public hideAside = () => {
        // MyStore.instance.dispatch(reducers.aside.ActionTypes.hide, null);
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.remove, null);
    }

    public clearOptions = () => {
        const options = Object.assign({}, this.modulesState.userPageMeta, this.modulesState.searchOptions, this.modulesState.filterOptions);
        return options;
    }

    public createUser = async options => {
        // const res: any = await userManage.userCreate(this, options);
        const res: any = await service.post(Urls.user_manage_create, options).end(this);
        this.modulesState.gUserId = res.res.gUserId;
        this.setModulesState();
        if (!res.err) {
            this.overrideUser({
                companyId: MyStore.instance.getState().user.currentcompanyId,
                roleCode: options.groupIds,
                userId: res.res.gUserId, 
                gUserId: res.res.userId,
            }).then(response => {
                if (!response.err) {
                    MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.remove, null);
                    // MyStore.instance.dispatch(reducers.aside.ActionTypes.hide, null);
                    this.getUserQuery(this.clearOptions());
                    Message.success('创建用户成功');
                }
            });
        }
    }
    /** 取消该用户 */
    public userInviteCancel = async options => {
        const res: any = await userManage.userInviteCancel(this, {
            departmentId: options.departmentId,
            guserId: options.gUserId,
            userId: options.userId,
        });
        if (!res.er) {
            this.getUserQuery(this.clearOptions());
            Message.success('取消该用户成功');
        }
    }

    public updateIsContactorIvew = (b) => {
        this.modulesState.isContactorView = b;
        this.setModulesState();
    }

    public getUserInfo = async options => {
        const res = await userManage.userInfo(this, options);
        if (!res.er) {
            this.modulesState.userInfo = res.res;
            this.modulesState.isContactorView = res.res.isContactor;
            if (res.res.isInnerUser === '0') {
                this.updateIsInnerUserControl(false);
            } else {
                this.updateIsInnerUserControl(true);
            }
            this.updateDescriptionMsg(res.res.description);
            this.setModulesState();
        }
    }

    public updateUserInfo = async options => {
        const res = await userManage.userUpdate(this, options);
        if (!res.er) {
            this.overrideUser({
                companyId: MyStore.instance.getState().user.currentcompanyId,
                roleCode: options.groupIds,
                userId: this.modulesState.gUserId,
                gUserId: this.modulesState.userInfo && this.modulesState.userInfo.userId,
            }).then(response => {
                if (!response.err) {
                    MyStore.instance.dispatch(reducers.aside.ActionTypes.hide, null);
                    this.getUserQuery(this.clearOptions());
                    Message.success('修改用户信息成功');
                }
            });
        }
    }

    /**
     * 给用户创建/编辑角色
     */
    public overrideUser = async (param) => {
        // const res: any = await job.setRoleData(this, param);
        const res = await service.put(Urls.set_user_role, param).end();
        return res;
    }

    public preCheck = async options => {
        const res = await userManage.userPreCheck(this, options);
        if (!res.er) {
            return res.res;
        }
    }

    public updataUserListPageMeta = (pageSize) => {
        this.modulesState.userListPageMeta.pageSize += pageSize;
        this.setModulesState();
    }

    public updateDescriptionMsg = msg => {
        this.modulesState.descriptionMsg = msg;
        this.setModulesState();
    }

    public updateDisableModal = b => {
        this.modulesState.disabledModal = b;
        this.setModulesState();
    }

    public updateDisabledUser = (userId, name) => {
        this.modulesState.disabledUserId = userId;
        this.modulesState.disabledName = name;
        this.setModulesState();
    }

    public updateRefreshEdit = (b) => {
        this.modulesState.refreshEdit = b;
        this.setModulesState();
    }

    public updateIsInnerUserControl = (b) => {
        this.modulesState.isInnerUserControl = b;
        this.setModulesState();
    }

    public updateSecurityMgr = async (param) => {
        const res = await userManage.securityMgrGet(this, param);
        if (!res.er) {
            this.modulesState.securityMgr = res.res;
            this.setModulesState();
        }
    }

    public userUnlock = async (param) => {
        const res = await userManage.securityMgrUnlock(this, param);
        if (!res.er) {
            Message.success('解锁成功');
            return true;
        }
    }

    public updateDisabledUnlock = (bool) => {
        this.modulesState.disabledUnlock = bool;
        this.setModulesState();
    }
    /**
     * 获取职位列表
     */
    public getJobList = async (userId?: string, gUserId?: string) => {
        const companyId = MyStore.instance.getState().user.currentcompanyId;
        const param = {
            pageNum: 1,
            pageSize: 999,
            companyId: companyId
        };
        const res: any = await job.queryRole(this, param);
        if (res.res) {
            if (userId) {
                const resData: any = await job.getQueryRole(this, { userId: this.modulesState.gUserId, gUserId: userId,companyId: companyId });
                this.modulesState.selectedJob = [resData.res && resData.res.roleCode || ''];
            }
            this.modulesState.jobList = res.res.items;
            this.setModulesState(this.modulesState);
        }
    }
}

export default new ModulesAction();




// WEBPACK FOOTER //
// ./src/display/platform/UserManage/Modules.Action.tsx